import React, { useState, useEffect } from 'react';
import { Paper, Typography, Box, Button, TextField, MenuItem, Grid, Alert } from '@mui/material';
import api from '../../api';

const SuperAdminSettings = () => {
  const [formData, setFormData] = useState({
    company_name: '', payroll_start_day: 16, payroll_end_day: 15,
    grace_period_mins: 15, grace_period_days: 3, leave_accumulation_freq: 'Monthly'
  });
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get('/settings/company').then(res => setFormData(res.data)).catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put('/settings/company', formData);
      setMsg({ type: 'success', text: 'Settings updated globally.' });
    } catch (err) { setMsg({ type: 'error', text: 'Failed to update.' }); }
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" color="secondary" gutterBottom>Super Admin Configuration</Typography>
      <Paper sx={{ p: 4 }}>
        {msg && <Alert severity={msg.type} sx={{ mb: 2 }}>{msg.text}</Alert>}
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}><Typography variant="h6" color="primary">Global Company Rules</Typography></Grid>
            <Grid item xs={12} md={6}><TextField size="small" fullWidth label="Company Name" value={formData.company_name} onChange={e => setFormData({...formData, company_name: e.target.value})} /></Grid>
            <Grid item xs={12} md={6}>
              <TextField select size="small" fullWidth label="Leave Accumulation Frequency" value={formData.leave_accumulation_freq} onChange={e => setFormData({...formData, leave_accumulation_freq: e.target.value})}>
                <MenuItem value="Monthly">Monthly</MenuItem><MenuItem value="Quarterly">Quarterly</MenuItem><MenuItem value="Yearly">Yearly</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>Payroll Cycle</Typography></Grid>
            <Grid item xs={6} md={3}><TextField size="small" type="number" fullWidth label="Start Day (e.g. 16)" value={formData.payroll_start_day} onChange={e => setFormData({...formData, payroll_start_day: parseInt(e.target.value)})} /></Grid>
            <Grid item xs={6} md={3}><TextField size="small" type="number" fullWidth label="End Day (e.g. 15)" value={formData.payroll_end_day} onChange={e => setFormData({...formData, payroll_end_day: parseInt(e.target.value)})} /></Grid>

            <Grid item xs={12}><Typography variant="h6" color="primary" sx={{ mt: 2 }}>Attendance & Grace Rules</Typography></Grid>
            <Grid item xs={6} md={3}><TextField size="small" type="number" fullWidth label="Grace Period (Mins)" value={formData.grace_period_mins} onChange={e => setFormData({...formData, grace_period_mins: parseInt(e.target.value)})} /></Grid>
            <Grid item xs={6} md={3}><TextField size="small" type="number" fullWidth label="Max Grace Occurrences/Month" value={formData.grace_period_days} onChange={e => setFormData({...formData, grace_period_days: parseInt(e.target.value)})} /></Grid>
            
            <Grid item xs={12} sx={{ mt: 2 }}><Button type="submit" variant="contained" color="secondary" size="large">Save Global Configurations</Button></Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default SuperAdminSettings;
